export default __webpack_public_path__ + "static/media/fulfillmentPlus_stacked.734bd620.svg";